<template>
    <div class="weather-mini">
        <span class="city-name">{{ city }}</span>
        <div class="weather-grid">
            <div class="weather-pill">
                <v-icon class="icon">mdi-weather-cloudy</v-icon>
                <span class="label">Temp</span>
                <span class="value">{{ weatherTemp }}°C</span>
            </div>
            <div class="weather-pill">
                <v-icon class="icon">mdi-water-percent</v-icon>
                <span class="label">Humidity</span>
                <span class="value">{{ weatherHumidity }}%</span>
            </div>
            <div class="weather-pill">
                <v-icon class="icon">mdi-weather-windy</v-icon>
                <span class="label">Wind</span>
                <span class="value">{{ weatherWind }} m/s</span>
            </div>
            <div class="weather-pill">
                <v-icon class="icon">mdi-weather-pouring</v-icon>
                <span class="label">Rain</span>
                <span class="value">{{ weatherRain }}%</span>
            </div>
        </div>
    </div>
</template>

<script setup>
import { defineProps } from 'vue'
defineProps({
    weatherTemp: Number,
    weatherHumidity: Number,
    weatherWind: Number,
    weatherRain: Number,
    city: String,
})
</script>

<style scoped>
.weather-mini {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 6px;
    color: white;
    margin-top: 4px;
    width: 100%;
}

.city-name {
    font-size: 12px;
    font-weight: 600;
    opacity: 0.9;
    white-space: nowrap;
    margin-top: 4px;
    padding-right: 6px;
}

.weather-grid {
    display: grid;
    grid-template-columns: repeat(2, auto);
    gap: 4px 6px;
    flex: 1;
    min-width: 0;
}

.weather-pill {
    display: flex;
    align-items: center;
    gap: 4px;
    background: rgba(255, 255, 255, 0.12);
    backdrop-filter: blur(3px);
    padding: 2px 6px;
    border-radius: 10px;
    font-size: 11px;
    line-height: 1;
    white-space: nowrap;
}

.icon {
    font-size: 14px;
    color: white;
}

.label {
    font-size: 10px;
    opacity: 0.75;
}

.value {
    font-weight: 600;
    font-size: 11px;
}

@media (max-width: 420px) {
    .weather-mini {
        flex-direction: column;
        align-items: flex-start;
    }

    .weather-grid {
        grid-template-columns: repeat(2, 1fr);
        width: 100%;
    }

    .city-name {
        margin-bottom: 4px;
    }
}
</style>
